import * as React from "react"

const MOBILE_BREAKPOINT = 768
/** Matches Tailwind `max-md` / desktop branch `md:` (min-width: 768px). */
const MOBILE_MQ = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useLayoutEffect(() => {
    const read = () => {
      setIsMobile(window.matchMedia(MOBILE_MQ).matches)
    }

    const mql = window.matchMedia(MOBILE_MQ)
    mql.addEventListener("change", read)
    window.addEventListener("resize", read)
    const vv = window.visualViewport
    vv?.addEventListener("resize", read)

    read()

    return () => {
      mql.removeEventListener("change", read)
      window.removeEventListener("resize", read)
      vv?.removeEventListener("resize", read)
    }
  }, [])

  return !!isMobile
}
